import { Hexagon } from "@/ui/Hexagon";
import cn from "classnames";
import { Ratio } from "react-bootstrap";

import classes from "./styles.module.scss";

export default function ({ className = "", src, alt = "", hoverable = true }) {
  return (
    <figure className={cn(className, classes.TeamMemberImage)} data-hoverable={hoverable}>
      <Hexagon alt>
        <div>
          <Hexagon alt />
        </div>
      </Hexagon>
      <Ratio aspectRatio={112}>
        <img src={src} alt={alt} />
      </Ratio>
    </figure>
  );
}
